import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-es6';
import { SettingService } from '../../../settings/services/setting.service';
import { DateHelper } from '../../helpers/date.helper';

@Pipe({
    name: 'chassisDate'
})
export class ChassisDatePipe implements PipeTransform {

    protected dateHelper = new DateHelper();

    public constructor(protected settingService: SettingService) {
    }

    transform(date: string, dateFormat: string | 'date' | 'time' | 'datetime', timeFormat: string): string {
        if (!date) {
            return '';
        }

        // get settings manual to prevent async operations
        const settings = this.settingService.settings.all();

        const dateSetting = settings.find(setting => setting.name === 'general.datetime.dateformat') || 'Y-m-d';
        const timeSetting = settings.find(setting => setting.name === 'general.datetime.timeformat') || 'H:i';

        let shouldParseDate;
        let shouldParseTime;

        const dateObject = moment(date);

        // If 'date', 'datetime' or 'time' was provided as date format,
        // check if we should parse the date and time
        if (['date', 'time', 'datetime'].includes(dateFormat)) {
            shouldParseDate = ['date', 'datetime'].includes(dateFormat);
            shouldParseTime = ['time', 'datetime'].includes(dateFormat);

            // Set date and convert setting dates from php to javascript dates
            dateFormat = this.dateHelper.phpToMomentFormat(dateSetting.value);
            timeFormat = this.dateHelper.phpToMomentFormat(timeSetting.value);
        } else {
            shouldParseDate = true;
            shouldParseTime = dateObject.creationData().format.toString().match(/HH\:mm/);

            // Set date and convert setting dates from php to javascript dates
            dateFormat = dateFormat ? dateFormat : this.dateHelper.phpToMomentFormat(dateSetting.value);
            timeFormat = timeFormat ? timeFormat : this.dateHelper.phpToMomentFormat(timeSetting.value);
        }

        try {
            if (!dateObject.isValid()) {
                return null;
            }

            if (shouldParseDate && shouldParseTime) {
                return dateObject.format(dateFormat + ' ' + timeFormat);
            }

            if (shouldParseDate) {
                return dateObject.format(dateFormat);
            }

            if (shouldParseTime) {
                return dateObject.format(timeFormat);
            }
        } catch (e) {
            console.error('error while transforming', e);
            return date;
        }
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/pipes/date/date.pipe.ts